exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".add-to-map-card-container {\n    background-color: white;\n    margin-bottom: 1rem;\n    margin-left: 1rem;\n    padding: 2rem;\n    flex: 1;\n    min-height: 60rem;\n}\n\n.flex-container {\n    display: flex;\n    align-items: center;\n}\n\n.zones-section-label-wrapper {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin: 1rem 0 3rem 0;\n    color: #707070;\n}", ""]);

// exports
